import { Card } from '../../components/Card';
import { Container, SubContainer } from '../../components/Container';
import { Info, Icon } from './styles';
import logo from '../../assets/images/unicred-logo-green.svg';
import arrow from '../../assets/icons/ubr-arrow-down.svg';
import Title from '../../components/Title';
import { CSSObject } from 'styled-components';
import { useContext, useEffect, useState } from 'react';
import { ConsentimentoRequest } from '../../context/ConsentimentoContext';
import { useNavigate } from 'react-router-dom';
import { CompartilhamentoContext } from '../../context/CompartilhamentoContext';
import bankIcon from '../../assets/images/bank-icon.png';
import { TransferenciaInteligenteRequest } from '../../context/TransferenciaInteligenteContext';
import { AutomaticoRequest } from '../../context/AutomaticoContext';

const Redirect = (): JSX.Element => {
  const history = useNavigate();
  const contextConsentimento = useContext(ConsentimentoRequest);
  const contextCompartilhamento = useContext(CompartilhamentoContext);
  const contextTransferenciaInteligente = useContext(TransferenciaInteligenteRequest);
  const contextAutomatico = useContext(AutomaticoRequest);
  const [logoSrc, setLogoSrc] = useState('');

  const titleStyles: CSSObject = {
    fontSize: '20px',
    maxWidth: '430px',
    margin: '0 auto',
  };
  const cardStyles: CSSObject = {
    padding: '32px 0px',
  };
  const infoStyles: CSSObject = {
    paddingBottom: '20px',
    paddingTop: '20px',
    backgroundColor: '#e9e9e9',
  };
  const logosStyles: CSSObject = {
    display: 'block',
    padding: '0 1rem',
    margin: '0 auto',
  };

  const validaLogo = () => {
    var logo = contextCompartilhamento.isShare
      ? contextCompartilhamento.dados.instituicao.icone
      : contextConsentimento.hasData
      ? contextConsentimento.iniciadora.urlLogoIniciadora
      : contextTransferenciaInteligente.hasData
      ? contextTransferenciaInteligente.iniciadora.urlLogoIniciadora
      : contextAutomatico.iniciadora.urlLogoIniciadora

    if (!logo) {
      setLogoSrc(bankIcon);
      return;
    } 
        
    const img = new Image();
    img.src = logo;
    img.onload = () => setLogoSrc(logo); 
    img.onerror = () => setLogoSrc(bankIcon);
  };

  const redirect = () => {
    setTimeout(() => {
      try {
        let redirectUrl;
        if (contextTransferenciaInteligente.hasData) {
          redirectUrl = contextTransferenciaInteligente.iniciadora.urlRedirecionamento;
        } else if (contextAutomatico.hasData) {
          redirectUrl = contextAutomatico.iniciadora.urlRedirecionamento;
        } else {
          redirectUrl = contextConsentimento.iniciadora.urlRedirecionamento;
        }
        
        if (redirectUrl) {
          window.location.href = redirectUrl;
        } else {
          history('/responses/redirect');
        }
      } catch (error) {
        console.error(error);
        history('/responses/redirect');
      }
    }, 5000);
  };

  useEffect(() => {
    if (!contextCompartilhamento.isShare && !contextConsentimento.hasData && !contextTransferenciaInteligente.hasData && !contextAutomatico.hasData) {
      history('/');
    }

    validaLogo();
    redirect();
  }, []);

  return (
    <Container>
      <SubContainer>
        <Title title="Redirecionamento">
          <p style={titleStyles}>
            {contextCompartilhamento.isShare
              ? 'Você será redirecionado para a instituição receptora para os próximos passos.'
              : 'Você será redirecionado para a instituição iniciadora de pagamentos'}
          </p>
        </Title>

        <Card style={cardStyles}>
          <div className="card-wrapper">
            <div className="card-body">
              <Icon className="unicred" style={logosStyles} src={logo} alt="Logo Unicred" />

              <Info style={infoStyles}>
                <Icon src={arrow} />
                <p>
                  {contextCompartilhamento.isShare
                    ? 'Estamos lhe redirecionando de volta para o ambiente da Instituição receptora'
                    : 'Estamos lhe redirecionando para o ambiente da Instituição selecionada'}
                </p>
              </Info>
              <Icon
                className="iniciadora"
                style={logosStyles}
                src={logoSrc}
                alt="Logo iniciadora"
              />
            </div>
          </div>
        </Card>
      </SubContainer>
    </Container>
  );
};

export default Redirect;
